import { useEffect, useRef, useCallback } from 'react';
import invoiceService from '../services/invoiceService';

const TERMINAL_STATUSES = ['COMPLETED', 'COMPLETED_WITH_ERRORS', 'FAILED'];

export function useInvoicePolling(jobId, onUpdate, onComplete) {
  const intervalRef = useRef(null);

  const stopPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const poll = useCallback(async () => {
    if (!jobId) return;
    try {
      const res = await invoiceService.getJob(jobId);
      const job = res.data;
      if (onUpdate) onUpdate(job, null);
      if (TERMINAL_STATUSES.includes(job.status)) {
        stopPolling();
        if (onComplete) onComplete(job);
      }
    } catch (err) {
      if (onUpdate) onUpdate(null, err);
    }
  }, [jobId, onUpdate, onComplete, stopPolling]);

  useEffect(() => {
    if (!jobId) return;
    poll();
    intervalRef.current = setInterval(poll, 10000);
    return () => stopPolling();
  }, [jobId, poll, stopPolling]);

  return { stopPolling };
}
